import { render, staticRenderFns } from "./loadingBtn.vue?vue&type=template&id=2908767a&scoped=true&"
import script from "./loadingBtn.vue?vue&type=script&lang=js&"
export * from "./loadingBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908767a",
  null
  
)

export default component.exports